var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from 'react';
import moment from 'moment';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SendIcon from '@mui/icons-material/Send';
import FundingLogActionsCard from './FundingLogActionsCard';
import { FundingLogStatusBadge } from './FundingLogBadges';
import { FundingLogHistoryIcon } from './FundingLogStatusHistoryPopup';
import { FundingLogComposerWrapper } from './FundingLogStyles';
import { FUNDING_LOG_DISPLAY_DATE_FORMAT } from './useFundingLog';
import { baseColors } from '../../../Themes/colors';
import { CommentsIcon } from '../../../components/icons';
var FUNDING_LOG_COMMENT_TYPE = { Code: 'FUNDLOG', Description: 'Funding Log' };
var FUNDING_LOG_COMMENT_TYPE_LABEL = 'Funding Log';
var formatCommentDateTime = function (value) {
    if (!value)
        return '';
    var parsed = moment(value);
    return parsed.isValid() ? parsed.format(FUNDING_LOG_DISPLAY_DATE_FORMAT) : '';
};
var getInitials = function (name) { return ((name || '')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(function (word) { return word.replace(/[^a-zA-Z]/g, '').charAt(0).toUpperCase(); })
    .join('')); };
var FundingLogCommentRow = function (_a) {
    var _b;
    var comment = _a.comment;
    return (React.createElement(Stack, { direction: "row", gap: 1.5, sx: { py: 1.25 } },
        React.createElement(Box, { sx: {
                width: 32,
                height: 32,
                borderRadius: '50%',
                backgroundColor: baseColors.greyPreset[55],
                color: baseColors.greyPreset[10],
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 12,
                fontWeight: 700,
                flexShrink: 0,
                mt: '2px',
            } }, getInitials(comment.CommentedBy)),
        React.createElement(Stack, { sx: { minWidth: 0, flex: 1, textAlign: 'left' }, gap: 0.5 },
            React.createElement(Stack, { direction: "row", alignItems: "baseline", gap: 0.75, flexWrap: "wrap" },
                React.createElement(Typography, { sx: { fontSize: 13, fontWeight: 700, color: baseColors.darkPreset[10] } }, comment.CommentedBy),
                React.createElement(Typography, { sx: { fontSize: 11, color: baseColors.greyPreset[30] } },
                    "\u00B7 ",
                    FUNDING_LOG_COMMENT_TYPE_LABEL,
                    " \u00B7 ",
                    formatCommentDateTime(comment.CreatedTime))),
            ((_b = comment.Subject) === null || _b === void 0 ? void 0 : _b.trim()) && (React.createElement(Typography, { sx: { fontSize: 13, fontWeight: 600, color: baseColors.darkPreset[10] } }, comment.Subject)),
            React.createElement(Typography, { sx: { fontSize: 13, color: baseColors.darkPreset[10], lineHeight: 1.5 } }, comment.Text))));
};
var FundingLogCommentComposer = function (_a) {
    var onSend = _a.onSend;
    var _b = useState(''), subject = _b[0], setSubject = _b[1];
    var _c = useState(''), message = _c[0], setMessage = _c[1];
    var _d = useState(false), isSubmitting = _d[0], setIsSubmitting = _d[1];
    var handleSend = function () { return __awaiter(void 0, void 0, void 0, function () {
        var trimmedMessage, isSuccessful;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    trimmedMessage = message.trim();
                    if (!trimmedMessage || isSubmitting || !onSend)
                        return [2];
                    setIsSubmitting(true);
                    return [4, Promise.resolve(onSend({
                            subject: subject.trim(),
                            message: trimmedMessage,
                            CommentType: FUNDING_LOG_COMMENT_TYPE,
                        }))];
                case 1:
                    isSuccessful = _a.sent();
                    setIsSubmitting(false);
                    if (isSuccessful) {
                        setSubject('');
                        setMessage('');
                    }
                    return [2];
            }
        });
    }); };
    return (React.createElement(FundingLogComposerWrapper, null,
        React.createElement(Stack, { direction: "row", alignItems: "center", gap: 1 },
            React.createElement(CommentsIcon, null),
            React.createElement(Typography, { sx: { fontSize: 14, fontWeight: 700, color: baseColors.darkPreset[10] } }, "Add a Comment")),
        React.createElement("input", { className: "subjectInput", placeholder: "Subject (optional)", value: subject, disabled: isSubmitting, onChange: function (event) { return setSubject(event.target.value); } }),
        React.createElement("div", { className: "textareaWrap" },
            React.createElement("textarea", { className: "messageTextarea", placeholder: "Add a note for the team...", rows: 5, value: message, disabled: isSubmitting, onChange: function (event) { return setMessage(event.target.value); } }),
            React.createElement("button", { type: "button", className: "sendBtn", onClick: handleSend, disabled: !message.trim() || isSubmitting, style: {
                    backgroundColor: message.trim() ? baseColors.successPreset[30] : baseColors.greyPreset[55],
                    opacity: isSubmitting ? 0.6 : 1,
                } },
                React.createElement(SendIcon, { sx: { fontSize: 16, color: baseColors.fullWhite } })))));
};
var FundingLogCommentsPanel = function (_a) {
    var row = _a.row, onClose = _a.onClose, comments = _a.comments, _b = _a.isLoadingComments, isLoadingComments = _b === void 0 ? false : _b, onAddComment = _a.onAddComment, _c = _a.canManage, canManage = _c === void 0 ? true : _c, _d = _a.canComment, canComment = _d === void 0 ? true : _d, currentUserRoleTier = _a.currentUserRoleTier, onAssignToMyself = _a.onAssignToMyself, onMoveToL2Manager = _a.onMoveToL2Manager, onMoveToSalesSupport = _a.onMoveToSalesSupport, onSetToFunded = _a.onSetToFunded, onReassignToOther = _a.onReassignToOther, onReturnToCM = _a.onReturnToCM, onStatusHistoryClick = _a.onStatusHistoryClick, onViewDetailsClick = _a.onViewDetailsClick;
    return (React.createElement(Box, { sx: { height: '100%', display: 'grid', gridTemplateRows: 'auto minmax(0, 1fr) auto', overflow: 'hidden' } },
        React.createElement(Stack, { direction: "row", alignItems: "flex-start", justifyContent: "space-between", sx: { px: 2, py: 2, borderBottom: "1px solid ".concat(baseColors.greyPreset[40]) } },
            React.createElement(Stack, { gap: 0.25, sx: { minWidth: 0 } },
                React.createElement(Typography, { sx: {
                        fontSize: 14,
                        fontWeight: 800,
                        color: baseColors.darkPreset[10],
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                    } }, row.customerName),
                React.createElement(Stack, { direction: "row", alignItems: "center", gap: 0.75 },
                    React.createElement(Typography, { sx: { fontSize: 13, color: baseColors.greyPreset[30] } }, row.contractId),
                    onViewDetailsClick && (React.createElement(Typography, { onClick: onViewDetailsClick, sx: {
                            fontSize: 12,
                            fontWeight: 700,
                            color: baseColors.successPreset[30],
                            textDecoration: 'underline',
                            cursor: 'pointer',
                            '&:hover': { color: baseColors.successPreset[10] },
                        } }, "View Deal")))),
            React.createElement(IconButton, { onClick: onClose, size: "small", sx: { flexShrink: 0 } },
                React.createElement(CloseIcon, { fontSize: "small" }))),
        React.createElement(Stack, { sx: { flex: '1 1 auto', minHeight: 0, overflowY: 'auto' } },
            React.createElement(FundingLogActionsCard, { status: row.status, tier: row.assigneeTier, assigneeName: row.assigneeName, canManage: canManage, currentUserRoleTier: currentUserRoleTier, onAssignToMyself: onAssignToMyself, onMoveToL2Manager: onMoveToL2Manager, onMoveToSalesSupport: onMoveToSalesSupport, onSetToFunded: onSetToFunded, onReassignToOther: onReassignToOther, onReturnToCM: onReturnToCM }),
            React.createElement(Box, { sx: { px: 2, pb: 2, borderBottom: "1px solid ".concat(baseColors.greyPreset[40]) } },
                React.createElement(Typography, { sx: { fontSize: 11, fontWeight: 700, letterSpacing: 1, color: baseColors.darkPreset[10], mb: 1 } }, "CURRENT STATUS"),
                React.createElement(Stack, { direction: "row", alignItems: "center", gap: 1 },
                    React.createElement(FundingLogStatusBadge, { value: row.status }),
                    React.createElement(IconButton, { size: "small", onClick: onStatusHistoryClick },
                        React.createElement(FundingLogHistoryIcon, { fill: baseColors.greyPreset[10] })))),
            React.createElement(Box, { sx: { px: 2, py: 2 } },
                React.createElement(Typography, { sx: { fontSize: 11, fontWeight: 700, letterSpacing: 1, color: baseColors.darkPreset[10], mb: 0.5 } }, "COMMENTS"),
                isLoadingComments ? (React.createElement(Typography, { variant: "body2", sx: { color: baseColors.greyPreset[30], textAlign: 'center', py: 2 } }, "Loading comments\u2026")) : comments.length > 0 ? (React.createElement(Stack, { divider: React.createElement(Box, { sx: { borderBottom: "1px solid ".concat(baseColors.greyPreset[55]) } }) }, comments.map(function (comment, index) { return (React.createElement(FundingLogCommentRow, { key: index, comment: comment })); }))) : (React.createElement(Typography, { variant: "body2", sx: { color: baseColors.greyPreset[30], py: 1 } }, "No comments yet.")))),
        canComment && React.createElement(FundingLogCommentComposer, { onSend: onAddComment })));
};
export default FundingLogCommentsPanel;
